module.exports = __webpack_public_path__ + "static/close-71077684efb1c8653ca6ff05f7909e82.png";